import React, { useEffect } from "react";

import { usePix } from "../../../../hooks";
import { PixReceipt } from "../../../../components/PixReceipt";
import { useActions } from "../../../../provider";

export function PixPaymentMethod() {
  const { actionsState, isLoading } = useActions();
  const { makePayment } = usePix();
  const { msisdn, plan, paymentData } = actionsState;

  useEffect(() => {
    makePayment();
  }, []);

  return (
    <PixReceipt
      plan={plan}
      paymentData={paymentData?.pix}
      isLoading={isLoading}
      msisdn={msisdn}
    />
  );
}
